var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1478_32132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9431 26.9998H7.39038V25.2225C7.39038 24.5808 7.91284 24.0615 8.55138 24.0615H19.7822C20.4239 24.0615 20.9432 24.584 20.9432 25.2225L20.9431 26.9998ZM8.24204 26.148H20.0943V25.2225C20.0943 25.0521 19.9553 24.9131 19.7849 24.9131H8.55171C8.38131 24.9131 8.24224 25.0521 8.24224 25.2225L8.24204 26.148Z",
    fill: "#001EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8336 24.9109H9.49939V23.1336C9.49939 22.492 10.0219 21.9727 10.6604 21.9727H17.6699C18.3116 21.9727 18.8309 22.4951 18.8309 23.1336L18.8311 24.9109H18.8336ZM10.3511 24.0591H17.982V23.1336C17.982 22.9633 17.8429 22.8242 17.6725 22.8242H10.6601C10.4897 22.8242 10.3507 22.9633 10.3507 23.1336L10.3511 24.0591Z",
    fill: "#001EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 7.3264C13.5705 7.3264 13.0139 7.08793 12.5995 6.65655C12.2134 6.25332 12.0004 5.72249 12.0004 5.16331C12.0004 4.60411 12.2134 4.07306 12.5995 3.67008C13.014 3.23845 13.5705 3 14.1666 3C14.7628 3 15.3193 3.23847 15.7338 3.66985C16.1199 4.07308 16.3329 4.60391 16.3329 5.16308C16.3329 5.72228 16.1199 6.25334 15.7338 6.65632C15.319 7.08795 14.7628 7.3264 14.1666 7.3264ZM14.1666 3.85149C13.8033 3.85149 13.4683 3.99619 13.2184 4.25742C12.9855 4.50153 12.855 4.82519 12.855 5.16304C12.855 5.50089 12.9828 5.82458 13.2184 6.06865C13.4681 6.32988 13.806 6.47458 14.1666 6.47458C14.53 6.47458 14.8649 6.32988 15.1149 6.06865C15.3477 5.82455 15.4782 5.50089 15.4782 5.16304C15.4782 4.82519 15.3504 4.5015 15.1149 4.25742C14.8649 3.9962 14.53 3.85149 14.1666 3.85149Z",
    fill: "#001EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6508 7.4317H22.2576C21.2413 7.4317 20.2788 6.93763 19.6912 6.10591L19.3222 5.58931L15.9042 5.58908V4.7373H19.7593L20.3809 5.61453C20.8123 6.21923 21.5108 6.57969 22.2546 6.57969H24.6478V7.4317H24.6508Z",
    fill: "#001EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99642 7.43146H3.68274V6.57969H5.99642C6.68906 6.57969 7.33929 6.27022 7.77637 5.7338L8.58822 4.7373H12.4265V5.58908H8.99149L8.435 6.27312C7.83883 7.00835 6.94742 7.43141 5.99645 7.43141L5.99642 7.43146Z",
    fill: "#001EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8441 22.8235H12.4886V9.80735C12.4886 9.38429 12.8351 9.03809 13.2579 9.03809H15.0748C15.4979 9.03809 15.8441 9.38452 15.8441 9.80735V22.8235ZM13.3401 21.9719H14.9952V9.8894H13.3401V21.9719Z",
    fill: "#001EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7407 6.90039H14.5925V9.46403H13.7407V6.90039Z",
    fill: "#001EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.68414 19.9224C3.10071 19.9224 1 18.0147 1 15.667V15.2412H10.3683V15.667C10.3683 18.0147 8.26763 19.9224 5.68414 19.9224ZM1.87994 16.0928C2.11547 17.7676 3.73086 19.0706 5.68414 19.0706C7.63742 19.0706 9.24987 17.7703 9.48835 16.0928H1.87994Z",
    fill: "#001EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00496 6.85107L5.79719 7.16347L2.38183 15.8261L1.5896 15.5137L5.00496 6.85107Z",
    fill: "#001EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16882 6.84863L9.58418 15.5112L8.79195 15.8236L5.37659 7.16103L6.16882 6.84863Z",
    fill: "#001EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6494 19.9224C20.0659 19.9224 17.9652 18.0147 17.9652 15.667V15.2412H27.3335V15.667C27.3335 18.0147 25.2328 19.9224 22.6494 19.9224ZM18.8481 16.0928C19.0836 17.7676 20.699 19.0706 22.6523 19.0706C24.6026 19.0706 26.218 17.7703 26.4565 16.0928H18.8481Z",
    fill: "#001EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1363 6.85059L26.5517 15.5132L25.7595 15.8256L22.3441 7.16298L23.1363 6.85059Z",
    fill: "#001EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9708 6.84961L22.763 7.16201L19.3477 15.8246L18.5554 15.5122L21.9708 6.84961Z",
    fill: "#001EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47424 26.1484H22.8623V27.0002H5.47424V26.1484Z",
    fill: "#001EFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1478_32132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndex);
export default __webpack_public_path__ + "static/media/index.49a56a7c395d8f41cdb56a5a8a91e19d.svg";
export { ForwardRef as ReactComponent };